import { Avatar, Box, EnhancedDimension } from '@factorialco/deprecated-design-system'

import { UnionSoftwareType } from 'modules/it_management/lib/software'

import * as styles from './index.vanilla.css'

interface Props {
  software: UnionSoftwareType
  size?: EnhancedDimension
}
const SoftwareLogo = ({ software, size }: Props) => {
  return (
    <Box className={styles.softwareLogo} width="fit-content">
      <Avatar size={size} label={software.name} url={software.logoUrl} />
    </Box>
  )
}

export default SoftwareLogo
